import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import PageLayout from "../../layout/page/PageLayout";
import EmptyState from "../../UI/feedback/EmptyState";
import {hasAnyRole} from "./roles";
import {selectCurrentUser} from "./authSlice";

const ADMIN_ROLES = ["ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_DEVELOPER"];

/**
 * Клиентское ограничение раздела. Роли приходят из login/refresh/me; если их
 * нет — доступ закрыт. Окончательно права всё равно проверяет бэкенд.
 */
const RequireRole = ({roles = ADMIN_ROLES, children}) => {
    const user = useSelector(selectCurrentUser);
    const allowed = hasAnyRole(user, roles);

    if (allowed) {
        return children;
    }

    return (
        <PageLayout
            title="Доступ ограничен"
            eyebrow="Права доступа"
            backTo="/panel"
            backLabel="На рабочий стол"
        >
            <EmptyState
                title="Недостаточно прав"
                description={`Раздел доступен ролям: ${roles.join(", ")}. Обратитесь к администратору, если доступ нужен.`}
                action={<Link className="btn btn-secondary" to="/panel">На рабочий стол</Link>}
            />
        </PageLayout>
    );
};

export default RequireRole;
